import React from 'react';
import { Form, Input, DatePicker, Select } from 'antd';
import dayjs from 'dayjs';
import { CaretDownOutlined } from '@ant-design/icons';
import { fixZIP, formatZIP } from '../../../utils.js';
import { COUNTRIES } from '../../helpers/misc';
import StreetAutocomplete from './StreetAutocomplete';
import PhoneInput from './PhoneInput';

const FormField = ({ field, formData, formErrors, onFieldChange }) => {
  //MA: TADY MAME DEFINOVANY JESTLI JE INPUT REQUIRED NEBO NE? TO BY MELO BYT V MISC U DEFINICE INPUTU NE?
  const requiredFields = ['first_name', 'last_name', 'email', 'zip', 'city'];
  const isRequired = requiredFields.includes(field.name);

  // Handle address selection for street field
  const handleAddressSelect = (addressData) => {
    const countryName = addressData.country || '';
    const countryEntry = Object.values(COUNTRIES).find(c => c.name === countryName);
    const countryCode = countryEntry ? countryEntry.code : '';

    const updates = [
      ['street', addressData.street],
      ['city', addressData.city || ''],
      ['zip', addressData.postalCode || ''],
      ['country', countryCode]
    ];
    
    updates.forEach(([fieldName, value], index) => {
      setTimeout(() => {
        onFieldChange(fieldName, value);
      }, index * 50); // Stagger updates by 50ms each
    });
  };

  const renderField = () => {
    switch (field.component) {
      case 'datepicker':
        return (
          <DatePicker
            id={field.name}
            placeholder={field.placeholder}
            format="DD.MM.YYYY"
            size="medium"
            inputReadOnly={("ontouchstart" in document.documentElement)}
            value={formData[field.name] ? dayjs(formData[field.name], 'DD.MM.YYYY') : null}
            onChange={(date, dateString) => onFieldChange(field.name, dateString)}
            defaultPickerValue={dayjs().subtract(18, 'year')}
            disabledDate={current => (current && current > dayjs().subtract(18, 'year').endOf('day'))}
          />
        );
      case 'phone':
        return (
          <PhoneInput
            id={field.name}
            value={formData[field.name]}
            onChange={(value) => onFieldChange(field.name, value)}
            placeholder={field.placeholder}
          />
        );
      case 'street':
        return (
          <StreetAutocomplete
            id={field.name}
            value={formData[field.name]}
            onChange={(value) => onFieldChange(field.name, value)}
            onAddressSelect={handleAddressSelect}
            placeholder={field.placeholder}
          />
        );
      case 'select':
        return (
          <Select
            id={field.name}
            placeholder={field.placeholder}
            defaultValue={field.defaultValue || null}
            value={formData[field.name] !== undefined ? formData[field.name] : (field.name === 'country' ? 'sk' : field.defaultValue || '')}
            onChange={(value) => onFieldChange(field.name, value)}
            suffixIcon={<CaretDownOutlined />}
            allowClear={false} // Zakázat křížek u všech selectů
            style={field.name === 'gender' ? { width: '50%', display: 'block' } : {}} // Gender select na polovinu šířky, zarovnaný vlevo
          >
            {field.options.map(option => {
              // Pro gender options (mají value/label)
              if (option.hasOwnProperty('value') && option.hasOwnProperty('label')) {
                return (
                  <Select.Option key={option.value || 'null'} value={option.value}>
                    {option.label}
                  </Select.Option>
                );
              }
              // Pro country options (mají code/name)
              return (
                <Select.Option key={option.code} value={option.code}>
                  {option.name}
                </Select.Option>
              );
            })}
          </Select>
        );
      case 'input':
      default:
        const handleChange = (e) => {
          onFieldChange(field.name, e.target.value);
        };
        const handleZipChange = (e) => {
          const cleanedZip = fixZIP(e.target.value);
          onFieldChange(field.name, cleanedZip);
        };
        const value = field.isZip ? formatZIP(formData[field.name]) : formData[field.name];
        const onChange = field.isZip ? handleZipChange : handleChange;
        return (
          <Input
            id={field.name}
            type={field.type || 'text'}
            value={value}
            placeholder={field.placeholder}
            onChange={onChange}
            maxLength={field.maxLength}
          />
        );
    }
  };

  return (
    <Form.Item
      label={field.label}
      validateStatus={formErrors[field.name] ? 'error' : ''}
      help={formErrors[field.name]}
      required={isRequired}
      className={
        field.component === 'datepicker' ? 'datepicker-container' :
        field.component === 'phone' ? 'phone-input-container' : ''
      }
    >
      {renderField()}
    </Form.Item>
  );
};


export default FormField;
